// extracted by extract-css-chunks-webpack-plugin
module.exports = {"featured":"mpNI-E"};